// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SET_GEOLOCATION: "SET_GEOLOCATION",
  OPEN_POPUP_ID: "OPEN_POPUP_ID",
  CLEAR_GEOLOCATION: "CLEAR_GEOLOCATION",
}
